<template>
  <div>
    <b-card
      style="
        width: 100%;

        margin-left: 0px;
      "
    >
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Facture N</label>

            <input
              class="form-control"
              disabled
              v-model="listes_service[0].id"
            />
          </div>
        </div>

        <div class="col">
          <div class="form-group">
            <label>Date</label>

            <input
              class="form-control"
              disabled
              v-model="listes_service[0].date"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Matricule</label>

            <input
              class="form-control"
              disabled
              v-model="listes_service[0].service.matr"
            />
          </div>
        </div>
      </div>

      <div class="table-responsive" style="border: 1px solid rgb(235 237 239)">
        <table class="table table-white">
          <thead>
            <tr>
              <!--  <th scope="col">#</th> -->

              <th style="background: #42b883; font-weight: bold; color: #fff">
                <b>QTS</b>
              </th>

              <th style="background: #42b883; font-weight: bold; color: #fff">
                <b>Désignation</b>
              </th>
              <th style="background: #42b883; font-weight: bold; color: #fff">
                <b>Prix.U</b>
              </th>
              <th style="background: #42b883; font-weight: bold; color: #fff">
                <b>Prix.T</b>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              style="border: 2px solid #dddddd"
              v-for="(prog, i) in programmes"
              :key="i"
            >
              <td>
                {{ prog.qts }}
              </td>
              <td>
                {{ prog.titre }}
              </td>
              <td>
                <span v-if="prog.man == 1">
                  {{ prog.prix.toFixed(3) }}
                </span>
                <span v-if="prog.man == 0"> - </span>
              </td>

              <td>
                <span v-if="prog.man == 1">
                  {{ Number(prog.qts) * Number(prog.prix) + ".000" }}
                </span>
                <span v-if="prog.man == 0"> - </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        

        <a
          :href="
            'https://apil.auto-turki.com/api/dynamic_pdf/pdf_vidange_man/' +
            this.$route.params.id
          "
          target="_blank"
          style="background-color: transparent !important"
        >
          <div class="md-layout-item md-small-size-10 md-size-10">
            <md-icon style="margin-top: -53px; margin-left: 36px"
              >print</md-icon
            >
          </div>
        </a>
      </div>

      <!--  <div style="padding: 9px; font-size: 33px">
        {{ numeroTolettre2 }} Dinar
      </div> -->

      <!-- ----------- -->

      <!-- -------------- -->
    </b-card>

    <!-- -------------------------- -->
  </div>
</template>


<script>
import { NumberToLetter } from "convertir-nombre-lettre";
import { apiDomain } from "../../config";
import axios from "axios";

export default {
  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  /*  mounted() {
    this.run()
  }, */
  components: {
    //  NumberToLetter
  },
  data() {
    return {
      programmes: [],
      de: "de",

      listes_service: {},
      selected: [],
      invoiceBase64: "",
    };
  },

  created() {
    this.fetchListesTypes(this.$route.params.id);
  },

  mounted() {
    /*   window.print();
    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
    var fileLink = document.createElement("a");

    fileLink.href = fileURL;
    fileLink.setAttribute("download", "file.pdf");
    document.body.appendChild(fileLink);

    fileLink.click(); */
  },

  computed: {
    somme: function () {
      var sum = 0;
      for (var i = 0; i < this.listes_service[0].Traitement.length; i++) {
        sum +=
          this.listes_service[0].Traitement[i].prix *
          this.listes_service[0].Traitement[i].qts;
      }
      return sum;
    },
    numeroTolettre() {
      var numberToLetters = require("number-2-letters");
      return numberToLetters(this.total);
    },

    numeroTolettre2() {
      const { NumberToLetter } = require("convertir-nombre-lettre");

      // return NumberToLetter();
      return NumberToLetter(this.total);
    },

    total: function () {
      let total = [];

      Object.entries(this.programmes).forEach(([key, val]) => {
        total.push(val.prix * val.qts); // the value of the current key.
      });
      return total.reduce(function (total, num) {
        return total + num;
      }, 0);
    },
  },

  methods: {
    printWindow: function () {
      window.print();
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", "file.pdf");
      document.body.appendChild(fileLink);

      fileLink.click();
    },
    async createInvoice() {
      //See documentation for all data properties
      const data = this.getSampleData();
      const result = await easyinvoice.createInvoice(data);
      this.invoiceBase64 = result.pdf;
    },
    async downloadInvoice() {
      //See documentation for all data properties
      const data = this.getSampleData();
      const result = await easyinvoice.createInvoice(data);
      easyinvoice.download("myInvoice.pdf", result.pdf);
      //	you can download like this as well:
      //	easyinvoice.download();
      //	easyinvoice.download('myInvoice.pdf');
    },
    async renderInvoice() {
      //See documentation for all data properties
      document.getElementById("pdf").innerHTML = "loading...";
      const data = this.getSampleData();
      const result = await easyinvoice.createInvoice(data);
      easyinvoice.render("pdf", result.pdf);
    },
    getSampleData() {
      return {
        //"documentTitle": "RECEIPT", //Defaults to INVOICE

        //"locale": "de-DE",
        //Defaults to en-US. List of locales: https://datahub.io/core/language-codes/r/3.html

        currency: "DNT",
        //Defaults to no currency. List of currency codes: https://www.iban.com/currency-codes

        taxNotation: "vat", //or gst
        marginTop: 25,
        marginRight: 25,
        marginLeft: 25,
        marginBottom: 25,
        logo: "https://public.easyinvoice.cloud/img/logo_en_original.png", //or base64
        //	"background": "https://public.easyinvoice.cloud/img/watermark-draft.jpg", //or base64
        sender: {
          company: "Sample Corp",
          address: "Sample Street 123",
          zip: "1234 AB",
          city: "Sampletown",
          country: "Samplecountry",
          //"custom1": "custom value 1",
          //"custom2": "custom value 2",
          //"custom3": "custom value 3"
        },
        client: {
          company: "Client Corp",
          address: "Clientstreet 456",
          zip: "4567 CD",
          city: "Clientcity",
          country: "Clientcountry",
          //"custom1": "custom value 1",
          //"custom2": "custom value 2",
          //"custom3": "custom value 3"
        },
        invoiceNumber: "2021.0001",
        invoiceDate: "1.1.2021",
        products: [
          {
            quantity: "2",
            description: "Test1",
            tax: 6,
            price: 33.87,
          },
          {
            quantity: "4",
            description: "Test2",
            tax: 21,
            price: 10.45,
          },
        ],
        bottomNotice: "Kindly pay your invoice within 15 days.",
        //Used for translating the headers to your preferred language
        //Defaults to English. Below example is translated to Dutch
        // "translate": {
        //     "invoiceNumber": "Factuurnummer",
        //     "invoiceDate": "Factuurdatum",
        //     "products": "Producten",
        //     "quantity": "Aantal",
        //     "price": "Prijs",
        //     "subtotal": "Subtotaal",
        //     "total": "Totaal"
        // }
      };
    },
    delete_service(id) {
      if (confirm("Azouz SVP Vérifier Sure ?")) {
      fetch(`${apiDomain}/api/delete_service/${id}`, {
        method: "delete",
      })
        .then((res) => res.json())
        .then((data) => {
          this.$noty.success("Service  supprimer avec Succès ! ");

          this.fetchListesTypes();
        })

        .catch((err) => console.log(err));
      }
    },
    fetchListesTypes(id) {
      fetch(`${apiDomain}/api/get_factureid_vidange/${this.$route.params.id}`)
        .then((res) => res.json())
        .then((res) => {
          this.listes_service = res.all_service;
          this.programmes = res.all_service[0].Traitement;
          ///  this.invoice.items =  res.all_service[0].Traitement;
        })
        .catch((err) => console.log(err));
    },
    printDownload() {
      let w = window.open();
      w.document.write(this.$refs.DownloadComp.$el.innerHTML);
      w.document.close();
      w.setTimeout(function () {
        w.print();
      }, 1000);
    },
  },
};
</script>

<style>
.md-table-head-container {
  height: auto;
  padding: 4px;
}
</style>

